import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faAngleLeft,
  faAngleRight,
  faArrowRight,
  faAward,
  faBackspace,
  faBars,
  faBuilding,
  faCalendarAlt,
  faCommentAlt,
  faCopy,
  faFileAlt,
  faCheck,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faClipboardListCheck,
  faDownload,
  faEnvelope,
  faEnvelopeOpenText,
  faFileArchive,
  faFilePdf,
  faGlobe,
  faInfoSquare,
  faLandmark,
  faLink,
  faMapSigns,
  faPlay,
  faSearch,
  faSlidersH,
  faTasks,
  faTimes,
  faThumbsUp,
  faTrophy,
  faUser,
  faUserHeadset,
  faUsers,
  faWindowMaximize,
  faWindowMinimize,
  faShareNodes,
} from '@fortawesome/pro-light-svg-icons';
import {
  faFacebook,
  faInstagram,
  faLinkedin,
  faPinterest,
  faXTwitter,
  faWhatsappSquare,
  faYoutube,
  faWeixin,
} from '@fortawesome/free-brands-svg-icons';

library.add(
  faAngleLeft,
  faAngleRight,
  faArrowRight,
  faAward,
  faBackspace,
  faBars,
  faBuilding,
  faCalendarAlt,
  faCommentAlt,
  faCopy,
  faFileAlt,
  faShareNodes,
  faCheck,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faClipboardListCheck,
  faDownload,
  faEnvelope,
  faEnvelopeOpenText,
  faFileArchive,
  faFilePdf,
  faGlobe,
  faInfoSquare,
  faLandmark,
  faLink,
  faMapSigns,
  faPlay,
  faSearch,
  faSlidersH,
  faTasks,
  faTimes,
  faThumbsUp,
  faTrophy,
  faUser,
  faUserHeadset,
  faUsers,
  faWindowMaximize,
  faWindowMinimize,
  faFacebook,
  faInstagram,
  faLinkedin,
  faPinterest,
  faXTwitter,
  faWhatsappSquare,
  faYoutube,
  faWeixin
);
